import { useAddFlag, useNavigationActions } from './provider';
import { useNavigationState } from './store';
import { useAppConfigStoreState } from './store/main';

// Combine the RSS with the Context
export const useNavigation = () => {
  const state = useNavigationState();
  const actions = useNavigationActions();
  return {
    ...actions,
    ...state
  };
};
export const useAppConfig = () => {
  const storeState = useAppConfigStoreState();
  const navigation = useNavigation();
  const addFlag = useAddFlag();
  return {
    ...storeState,
    ...navigation,
    addFlag
  };
};